module.exports = __webpack_public_path__ + "img/card_promenada.3836aefa.jpg";